/**
 * Project : workspace
 * File    : ColorCard.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.inventory.product.detail.component

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import androidx.compose.ui.zIndex
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.commerce.feature.inventory.viewModel.product_color.ProductColorViewModel
import com.parmartechnologies.core.feature.inventory.color.model.ProductColor
import com.parmartechnologies.core.feature.inventory.inventory.model.Inventory
import theme.color

@Composable
/**
 * Executes the color card operation.
 *
 * @receiver TODO
 * @param cID The c i d.
 * @param selectedColorId The selected color id.
 * @param filteredInventory The filtered inventory.
 * @param onClick The on click.
 * @return Unit – no return value.
 */
fun ColorCard(cID: String?, selectedColorId: String?, filteredInventory:List<Inventory>, onClick: (String?) -> Unit) {
    var color: ProductColor? by remember { mutableStateOf( null) }
    val businessViewModel = BusinessViewModel()
    val myBusiness = businessViewModel.myBusiness.collectAsState()
    /**
 * Executes the is color present in inventory operation.
 *
 * @receiver TODO
 * @param fInv The f inv.
 * @param cId The c id.
 * @return The resulting boolean.
 */
    fun isColorPresentInInventory(fInv: List<Inventory>, cId: String?): Boolean {
        var isEnabledForClick = false
        fInv.forEach {item->
            if(item.ColorID.isNotEmpty() && !cId.isNullOrEmpty() && item.ColorID == cID){
                isEnabledForClick = true
            }
        }
        return isEnabledForClick
    }
    val isEnabled = isColorPresentInInventory(filteredInventory, cID)

    LaunchedEffect(key1 = Unit) {
        ProductColorViewModel(business = myBusiness.value).getColorById(cID) { colorFromDb -> color = colorFromDb }
    }
    if(color != null && color!!.Hex.isNotEmpty()){
        Row (modifier = Modifier.width(80.dp).height(60.dp).padding(4.dp), verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.Center){
            Row(
                modifier = Modifier
                    .height(if(isEnabled || filteredInventory.isEmpty()) 60.dp else 40.dp).width(if(isEnabled || filteredInventory.isEmpty()) 80.dp else 60.dp)
                    .background(color!!.Hex.color(),
                        RoundedCornerShape(12.dp)
                    ).clip(RoundedCornerShape(12.dp))
//                    .border(2.dp,color=
//                    if(cID == selectedColorId) ThemeColor.shared().PrimaryColor.copy(alpha = 0.5f)
//                     else ThemeColor.shared().PrimaryColor
//                        ,shape = RoundedCornerShape(8.dp))
                    .zIndex(1f)
                    .clickable(enabled = isEnabled || filteredInventory.isEmpty()) {
                        onClick(cID)
                    },
            ) {

            }
        }
    }

}